import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'canx';
export const route = 'canx/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/CancellationPage')));